export default "__VITE_ASSET__SmAjOJiK__"